<!--
 * @Author: liushuaibo liushuaibo@yangxuan.net
 * @Date: 2023-07-31 17:27:42
 * @LastEditors: liushuaibo liushuaibo@yangxuan.net
 * @LastEditTime: 2023-08-01 14:56:03
 * @FilePath: \partner.chaoyongtuan.com\src\components\business\sampleSpecs\components\remarkDialog.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<el-dialog title="规格备注" :visible.sync="visible" :before-close="beforeClose" width="400px" :append-to-body="true">
		<div class=" flex-row flex-just-start">
			<p class="mr-16 nowarp">备注内容</p>
			<el-input type="textarea" :rows="3" placeholder="请输入" v-model="remark" />
		</div>
		<div slot="footer">
			<el-button @click="visible = false">取 消</el-button>
			<el-button type="primary" @click="confirm">确 认</el-button>
		</div>
	</el-dialog>
</template>
<script>
export default {
	data() {
		return {
			visible: false,
			remark: '',
		};
	},
	methods: {
		show(remark = '') {
			this.remark = remark;
			this.visible = true;
		},
		confirm() {
			this.$emit('editRemark', this.remark);
			this.beforeClose();
		},
		beforeClose() {
			this.remark = '';
			this.visible = false;
		},
	},
};
</script>
